import env from '../env';
import { sendGet, sendPost } from './dataUtilities';

export const PACTSAFE_BASE_URL = env.pactSafeBaseUrl;

export const getPactSafeSocialEcommContracts = () => sendGet(
  `${PACTSAFE_BASE_URL}/published?gid=${env.pactSafeSocialEcommGroupId}&sid=${env.pactSafeAccessId}`,
  {},
);

export const signPactSafeSocialEcommContracts = (email: string, contracts: string) => sendPost(
  `${PACTSAFE_BASE_URL}/send?sig=${email}&vid=${contracts}&gid=${env.pactSafeSocialEcommGroupId}&et=agreed&cus=%5Bobject%20Object%5D&tm=0&sid=${env.pactSafeAccessId}`,
  {},
  {},
);

export const getPactSageIntroProductContracts = () => sendGet(
  `${PACTSAFE_BASE_URL}/published?gid=${env.pactSafeIntroProductGroupId}&sid=${env.pactSafeAccessId}`,
  {},
);

export const signPactSafeIntroProductContracts = (email: string, contracts: string) => sendPost(
  `${PACTSAFE_BASE_URL}/send?sig=${email}&vid=${contracts}&gid=${env.pactSafeIntroProductGroupId}&et=agreed&cus=%5Bobject%20Object%5D&tm=0&sid=${env.pactSafeAccessId}`,
  {},
  {},
);
